export default "__VITE_ASSET__CqiiGLwC__"